import React from 'react';
import { motion } from 'framer-motion';
import { ActivityIcon } from 'lucide-react';
export function PainSection() {
  return <section id="problema" className="py-16 md:py-24 bg-[#0D0D0D] relative border-t border-white/5" data-id="element-233">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-234">
        <div className="max-w-4xl mx-auto" data-id="element-235">
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="bg-gradient-to-br from-[#111111] to-[#0A0A0A] p-8 md:p-12 rounded-2xl border border-[#50C878]/30 shadow-[0_0_30px_rgba(80,200,120,0.1)] relative overflow-hidden group hover:border-[#50C878]/60 transition-colors duration-500" data-id="element-236">
            {/* Background accent */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#50C878]/5 rounded-full blur-3xl -mr-32 -mt-32 pointer-events-none group-hover:bg-[#50C878]/10 transition-colors duration-500" data-id="element-237"></div>

            <div className="flex flex-col md:flex-row gap-8 items-start relative z-10" data-id="element-238">
              <div className="flex-shrink-0 bg-[#50C878]/10 p-4 rounded-full border border-[#50C878]/30 shadow-[0_0_15px_rgba(80,200,120,0.2)]" data-id="element-239">
                <ActivityIcon className="w-10 h-10 text-[#50C878]" data-id="element-240" />
              </div>

              <div data-id="element-241">
                <h2 className="text-2xl md:text-3xl font-bold text-white mb-6 leading-tight flex items-center gap-3" data-id="element-242">
                  El Diagnóstico Clínico{' '}
                  <span className="text-[#50C878]" data-id="element-243">🩺</span>
                </h2>

                <blockquote className="text-xl md:text-2xl text-[#C0C0C0] italic leading-relaxed border-l-4 border-[#50C878] pl-6 shadow-[-10px_0_15px_-10px_rgba(80,200,120,0.3)]" data-id="element-244">
                  "¿Tu flujo de caja es errático? Eso es una patología mortal
                  para cualquier empresa en USA. Mientras otros 'especialistas'
                  te cobran por subir fotos a Instagram,{' '}
                  <span className="text-white font-bold" data-id="element-245">
                    nosotros operamos con precisión quirúrgica.
                  </span>
                  "
                </blockquote>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}